export var PeoplePlatformRoutes = {
    "/core-hr": {
        "name": "appLayout.harriSH.core-hr",
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | CoreHR"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../team-live/availability-requests/availability-requests-shared.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../employment-types/employment-types.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../work-limit/work-limit.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./people-platform.module.js");
                }
            }
        ]
    },
    "/tl-core-hr": {
        "name": "appLayout.schedule.core-hr",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../team-live/availability-requests/availability-requests-shared.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../employment-types/employment-types.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../work-limit/work-limit.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./people-platform.module.js");
                }
            }
        ]
    },
    "/tl-people-list?view&source&scheduleVisibility&hireDateFrom&hireDateTo&leaveDateFrom&leaveDateTo&employeeStatus": {
        "name": "appLayout.schedule.core-hr.list",
        "type": "frontend",
        "views": {
            "people-platform-body": {
                component: "peopleListContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["people_platform"]
        },
        "params": {
            view: {
                dynamic: true,
            },
            source: {
                dynamic: true,
            },
            scheduleVisibility: {
                dynamic: true,
            },
            hireDateFrom: {
                dynamic: true,
            },
            hireDateTo: {
                dynamic: true,
            },
            leaveDateFrom: {
                dynamic: true,
            },
            leaveDateTo: {
                dynamic: true,
            },
            employeeStatus: {
                dynamic: true,
            },
        }
    },
    '/profile-details?user_id&tab&brand_id&shift_start_time&shift_end_time&location_id&engagement_tab&from_date&to_date': {
        "name": "appLayout.harriSH.core-hr.profile",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./people-platform.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../modules/team_schedule/employer/employee-card/employee-card.module.js");
                }
            },
            {
                type: 'chunk', loader: () => {
                    return import("../../hmodules/right-to-work/right-to-work.module.js");
                }
            },
            {
                type: 'chunk', loader: () => {
                    return import("../../hmodules/trust-id/trust-id.module.js");
                }
            },
            {
                type: 'chunk', loader: function () {
                    return import("../../modules/docs/docs.module.js");
                }
            },
            {
                type: 'chunk', loader: function () {
                    return import("../../hmodules/pos-integration/pos-integration.module.js");
                }
            },
            {
                type: 'chunk', loader: function () {
                    return import("../../hmodules/on-boarding/on-boarding.module.js");
                }
            }
        ]
    },
    '/tl-profile-details?user_id&tab&brand_id&shift_start_time&shift_end_time&location_id&source': {
        "name": "appLayout.schedule.core-hr.profile",
        "params": {
            source: {
                dynamic: true,
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../modules/team_schedule/employer/employee-card/employee-card.module.js");
                }
            },
            {
                type: 'chunk', loader: function () {
                    return import("../../modules/docs/docs.module.js");
                }
            },
            {
                type: 'chunk', loader: function () {
                    return import("../../hmodules/pos-integration/pos-integration.module.js");
                }
            },
            {
                type: 'chunk', loader: function () {
                    return import("../../hmodules/on-boarding/on-boarding.module.js");
                }
            }
        ]
    }
};
